import styled from "@emotion/styled";
import { darkGrey2, lightGrey3, SPACE_MONO, transparentWhite, white } from "@stepfinance/react";
import { Collapse } from "antd";

export const PortfolioCard = styled.div`
  border-radius: 8px;
  padding: 20px;
  background: ${darkGrey2};

  h2 {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 400;
    color: ${transparentWhite};
  }

  .total-value-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .net-worth {
      color: ${white};
      font-family: ${SPACE_MONO};
      font-size: 30px;
      font-weight: bold;
      line-height: 32px;
      margin-right: 10px;
    }
    .spinner-container {
      margin-left: 8px;
    }
  }
`;

export const PortfolioCollapse = styled(Collapse)`
  border-radius: 8px;
  margin: 0;
  padding: 0;
  background: ${lightGrey3};

  .ant-collapse-header {
    height: 46px;
    font-weight: 700;
    color: ${white} !important;
  }
  .ant-collapse-content {
    overflow: hidden;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    border-radius: 0 0 8px 8px;
    padding: 12.5px 0 !important;
    background: ${lightGrey3} !important;
    color: ${white};
  }
`;
